(() => {
  if (window.gbRumbaSeatOptionsV2) return;
  window.gbRumbaSeatOptionsV2 = true;
  let pending = false;
  function revealCurrent() {
    document.querySelectorAll('.gb-seat-picker--dynamic .gb-seat-picker__options').forEach(rail => {
      const current = rail.querySelector('[aria-current="page"]');
      if (current) rail.scrollLeft = Math.max(0, current.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + current.offsetWidth / 2);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealCurrent, {once:true}); else revealCurrent();
  document.addEventListener('shopify:section:load', revealCurrent);
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-gb-seat-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.getAttribute('aria-current') === 'page') { event.preventDefault(); return; }
    const picker = link.closest('[data-gb-seat-picker]');
    const section = picker.closest('.shopify-section');
    const productSection = picker.closest('[data-section-type="product"]');
    if (!section || !productSection || !window.theme?.sections || !window.theme?.Product) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    picker.setAttribute('aria-busy', 'true');
    const status = picker.querySelector('[data-gb-seat-status]');
    status.textContent = status.dataset.loading;
    const destination = new URL(link.href);
    const current = new URL(location.href);
    if (current.searchParams.has('preview_theme_id')) destination.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(destination, {credentials: 'same-origin', signal: controller.signal});
      if (!response.ok || new URL(response.url).origin !== location.origin) throw new Error('Product unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = doc.querySelector('[data-section-type="product"]')?.closest('.shopify-section');
      const next = replacement?.querySelector('[data-gb-seat-picker]');
      if (!next || !replacement.querySelector('form[action*="/cart/add"]')) throw new Error('Product markup unavailable');
      const sectionId = productSection.dataset.sectionId;
      section.dispatchEvent(new CustomEvent('shopify:section:unload', {bubbles: true, detail: {sectionId}}));
      section.replaceWith(replacement);
      history.pushState({gbRumbaSeat: true}, '', destination.pathname + destination.search);
      document.title = doc.title;
      document.querySelectorAll('form[action*="/localization"] input[name="return_to"]').forEach((input) => {
        input.value = destination.pathname;
      });
      for (const selector of ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:url"]', 'meta[property="og:image"]']) {
        const incoming = doc.head.querySelector(selector);
        const existing = document.head.querySelector(selector);
        if (incoming && existing) existing.replaceWith(incoming);
      }
      replacement.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true, detail: {sectionId: replacement.querySelector('[data-section-type="product"]').dataset.sectionId}}));
      const target = replacement.querySelector('[data-gb-seat-link][aria-current="page"]');
      if (target) {
        const rail = target.closest('.gb-seat-picker__options');
        rail.scrollLeft = Math.max(0, target.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + target.offsetWidth / 2);
        target.focus({preventScroll: true});
      }
      document.dispatchEvent(new CustomEvent('gb:product:changed', {detail: {url: destination.pathname}}));
    } catch (error) {
      location.assign(destination.href);
    } finally {
      clearTimeout(timer);
      pending = false;
    }
  });
  window.addEventListener('popstate', () => {
    if (document.querySelector('[data-gb-seat-picker]')) location.reload();
  });
})();
